/* Publish by EComposer at 2026-10-01 16:33:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rh4we941upd"]=  window.__ectimmers["ecom-rh4we941upd"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rh4we941upd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rh4we941upd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-80r4xg6l9uf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-80r4xg6l9uf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eeth94h5xgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eeth94h5xgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-anl83lxsek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anl83lxsek', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rs0sjy8djg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rs0sjy8djg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkq5ryz3f3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkq5ryz3f3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlr2lggtmyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlr2lggtmyq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-982yuo83ov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-982yuo83ov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idqrea6i7se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idqrea6i7se', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38zsky026hl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38zsky026hl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo373bml66k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo373bml66k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3gsmxi3nukd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3gsmxi3nukd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3bcts2923oc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3bcts2923oc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1a5uc79km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1a5uc79km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmidxv4vg9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmidxv4vg9e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1o3a2t5p29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1o3a2t5p29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljkkpdba9i9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljkkpdba9i9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3lyul8tmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3lyul8tmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wvxkkqdz9nm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wvxkkqdz9nm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3whm01r4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3whm01r4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eufyoni10s4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eufyoni10s4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vumqh2j2om8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vumqh2j2om8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rd5gochi5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rd5gochi5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hw6ytifoau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hw6ytifoau', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cw1xcd6x23').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cw1xcd6x23', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5i67kyfoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5i67kyfoq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0n0imcetg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0n0imcetg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13wkwlmujmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13wkwlmujmr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ehlxck60mve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ehlxck60mve', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9rcefawlgd4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9rcefawlgd4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31kkwjmsked').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31kkwjmsked', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5r0h7th3u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5r0h7th3u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3svygrojoo2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3svygrojoo2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98driy4z7rd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98driy4z7rd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2734f7fvvup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2734f7fvvup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rddbx1u0b5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rddbx1u0b5h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgs2mi2hsoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgs2mi2hsoo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0bgd76h1dyn7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0bgd76h1dyn7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d2sid745gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d2sid745gn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idw4kgu8cbt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idw4kgu8cbt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p89u89daaxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p89u89daaxb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w15702nns8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w15702nns8b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1n7x2egwsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1n7x2egwsc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92b1fku745').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92b1fku745', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7befoc6u8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7befoc6u8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrfhxr3yjpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrfhxr3yjpi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2k4wojtp5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2k4wojtp5s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xllc18u69tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xllc18u69tb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su5rrehwbcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su5rrehwbcg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8d1oe90he9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8d1oe90he9u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9o95sk8fja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9o95sk8fja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvmrf4v6tzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvmrf4v6tzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6oooy5osjtb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6oooy5osjtb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsknrx2onn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsknrx2onn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-new10rb00lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-new10rb00lr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pldwn742xy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pldwn742xy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2ybtby88j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2ybtby88j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gyxaec68nho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gyxaec68nho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfxwmfnta3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfxwmfnta3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2l0emeepm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2l0emeepm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hl9liw41o5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hl9liw41o5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u82a2v8sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u82a2v8sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5uu6tdz3nl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5uu6tdz3nl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wmqw7fujnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmqw7fujnt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iusklzgemx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iusklzgemx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4irdghtjq96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4irdghtjq96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8av75k1a8w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8av75k1a8w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xzrop5o0ejc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xzrop5o0ejc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ze9oyvbj0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ze9oyvbj0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ymoz4eui7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ymoz4eui7r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-700csuwkeob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-700csuwkeob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8snkxx707vh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8snkxx707vh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ez1rxfwg4s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ez1rxfwg4s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9rsw54265c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9rsw54265c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dy59c3dnsm5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dy59c3dnsm5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbkuqea696h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbkuqea696h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-epuazhvx3bd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-epuazhvx3bd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q2o2bctbax').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q2o2bctbax', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s2m5qhfyb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s2m5qhfyb4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wf93n4j6tqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wf93n4j6tqs', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q579a0puh7"]=  window.__ectimmers["ecom-q579a0puh7"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-q579a0puh7"]["lxbrbmaez"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-q579a0puh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q579a0puh7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1wz7qgyo4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1wz7qgyo4b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjxedvghbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjxedvghbp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-je7p68c2jnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-je7p68c2jnl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tto0ti55iv9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tto0ti55iv9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vv203tz8pw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vv203tz8pw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fuorcmw2e8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fuorcmw2e8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ntyizzjd3z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ntyizzjd3z', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llz9wc71pmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llz9wc71pmk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0j90v6u8zj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0j90v6u8zj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nh3uor2aqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nh3uor2aqk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iqc2uzkth4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqc2uzkth4c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqeym3k6d5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqeym3k6d5d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qzjo97b94').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qzjo97b94', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f630xw5bm9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f630xw5bm9i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8vy7n9hnc8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8vy7n9hnc8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5sgeca8f4mr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5sgeca8f4mr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pcor20bxm3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pcor20bxm3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1tdbgiyalbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tdbgiyalbk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3f47oloas78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3f47oloas78', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kan2u9bqhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kan2u9bqhf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lxcgguw1eum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lxcgguw1eum', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mh7jdhdqu3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mh7jdhdqu3b', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-egga6e89nud"]=  window.__ectimmers["ecom-egga6e89nud"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-egga6e89nud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-egga6e89nud', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1cxu6x5kz6n"]=  window.__ectimmers["ecom-1cxu6x5kz6n"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-1cxu6x5kz6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cxu6x5kz6n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n9w6bahlaum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n9w6bahlaum', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-345tz7y1gyb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-345tz7y1gyb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-al4k9ov5swv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-al4k9ov5swv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqr5tmrt6ql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqr5tmrt6ql', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ut8blvu398t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ut8blvu398t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4d85k1fjof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4d85k1fjof', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0r1vv3cv5w2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0r1vv3cv5w2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ngh2w2ggu3j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ngh2w2ggu3j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55sgpzf7lqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55sgpzf7lqm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r77we9vttnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r77we9vttnj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpv1gn0bri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpv1gn0bri', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jn4klifz12m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jn4klifz12m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7w0h79gw3r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7w0h79gw3r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bcnchak4qim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bcnchak4qim', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lpuuvelzobj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lpuuvelzobj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xedyyorzewf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xedyyorzewf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgckdex1w4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgckdex1w4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izvotbpjwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izvotbpjwm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqc5pxlimt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqc5pxlimt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-un56hcv3vih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-un56hcv3vih', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2cpgq6v0y55"]=  window.__ectimmers["ecom-2cpgq6v0y55"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-2cpgq6v0y55').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cpgq6v0y55', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}